/** Capability ids a native shell reports in `bridge.hello`. A plain browser reports none. */
export const DEVICE_CAPABILITY_IDS = [
    "cardReader.m2",
    "cardReader.server",
    "piSocket",
    "drawer",
    "printControl",
    "lockTask",
];
const KNOWN = new Set(DEVICE_CAPABILITY_IDS);
/**
 * Immutable set of capabilities a device reports.
 * Unknown ids are dropped so a newer shell never breaks an older page.
 */
export class DeviceCapabilities {
    ids;
    constructor(ids) {
        this.ids = ids;
        Object.freeze(this);
    }
    /** Build from the raw `capabilities` list; non-strings and unknown ids are ignored. */
    static parse(raw) {
        const out = new Set();
        for (const v of raw ?? []) {
            if (typeof v === "string" && KNOWN.has(v))
                out.add(v);
        }
        return new DeviceCapabilities(out);
    }
    /** A device with no capabilities (plain browser). */
    static none() {
        return new DeviceCapabilities(new Set());
    }
    has(id) {
        return this.ids.has(id);
    }
    /** True when every id is present (vacuously true for an empty list). */
    hasAll(ids) {
        for (const id of ids)
            if (!this.ids.has(id))
                return false;
        return true;
    }
    /** Ids in canonical order. */
    toArray() {
        return DEVICE_CAPABILITY_IDS.filter((id) => this.ids.has(id));
    }
}
/** Each action needs ANY ONE of the listed capabilities. */
const ACTION_NEEDS = Object.freeze({
    tenderCash: ["drawer"],
    kickDrawer: ["drawer"],
    cashPayout: ["drawer"],
    reprint: ["printControl"],
    collectCard: ["cardReader.m2", "cardReader.server"],
});
/** Whether a hardware-gated action should be offered on this device. */
export function canPerform(action, caps) {
    return ACTION_NEEDS[action].some((c) => caps.has(c));
}
//# sourceMappingURL=DeviceCapabilities.js.map